const React = require('react');

const { createContext, useContext } = React;

const ModuleContext = createContext();

const useModuleContext = () => useContext(ModuleContext);

const context = { ModuleContext, useModuleContext };
module.exports = context;
